import React, { useEffect, useState } from "react";
import Select from "react-select";

import { apiService } from "service/ApiService";

export default function CompanySelector({ defaultValue = null, handler }) {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const handleChange = (e) => {
    setSelectedCompany(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getCompanies = async () => {
    try {
      const dataResponse = await apiService.get(`api/companies`);
      setCompanies(dataResponse.map((item) => ({ value: item._id, label: item.name })));
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const setNewValue = () => {
    const selectedCompany = companies.find((company) => company.value === defaultValue);
    if (selectedCompany) setSelectedCompany(selectedCompany);
  };

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Select
        isClearable={true}
        styles={customStyles}
        className="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
        options={companies}
        noOptionsMessage={() => "No companies available"}
        value={selectedCompany}
        onChange={handleChange}
        placeholder="Select company"
      />
    </>
  );
};
